export const categories = {
  work: {
    name: 'for work',
    img: './img/gifts/gift-for-work.png',
  },
  health: {
    name: 'for health',
    img: './img/gifts/gift-for-health.png',
  },
  harmony: {
    name: 'for harmony',
    img: './img/gifts/gift-for-harmony.png',
  },
};
